export var ROUTE_ACCESSES = {
    users: {
        index: 'users.index',
        store: 'users.store',
        show: 'users.show',
        update: 'users.update',
        destroy: 'users.destroy'
    },
    brokers: {
        index: 'brokers.index',
        store: 'brokers.store',
        destroy: 'brokers.destroy'
    },
    pairs: {
        index: 'pairs.index',
        store: 'pairs.store',
        show: 'pairs.show',
        update: 'pairs.update',
        destroy: 'pairs.destroy'
    },
    accounts: {
        index: 'accounts.index',
        store: 'accounts.store',
        show: 'accounts.show',
        update: 'accounts.update',
        destroy: 'accounts.destroy'
    },
    balanceCurrency: {
        index: 'balanceCurrency.index',
        store: 'balanceCurrency.store',
        destroy: 'balanceCurrency.destroy'
    },
    clients: {
        index: 'clients.index',
        store: 'clients.store',
        destroy: 'clients.destroy'
    },
    algorithms: {
        liquidityMaker: {
            index: 'algorithms.liquidityMaker.index',
            store: 'algorithms.liquidityMaker.store',
            update: 'algorithms.liquidityMaker.update',
            show: 'algorithms.liquidityMaker.show'
        },
        dexArbitrage: {
            index: 'algorithms.dexArbitrage.index',
            store: 'algorithms.dexArbitrage.store',
            update: 'algorithms.dexArbitrage.update',
            show: 'algorithms.dexArbitrage.show'
        },
        pingPong: {
            index: 'algorithms.pingPong.index',
            store: 'algorithms.pingPong.store',
            update: 'algorithms.pingPong.update',
            show: 'algorithms.pingPong.show'
        },
        eSignal: {
            index: 'algorithms.eSignal.index',
            store: 'algorithms.eSignal.store',
            update: 'algorithms.eSignal.update',
            show: 'algorithms.eSignal.show'
        },
        volumeMaker: {
            index: 'algorithms.volumeMaker.index',
            store: 'algorithms.pingPong.store',
            update: 'algorithms.pingPong.update',
            show: 'algorithms.pingPong.show'
        },
        orders: {
            index: 'algorithms.orders.index'
        },
        trades: {
            index: 'algorithms.trades.index'
        },
        activity: {
            index: 'algorithms.activity.index'
        },
        hedging: {
            index: 'algorithms.hedging.index'
        }
    },
    processes: {
        index: 'processes.index',
        store: 'processes.store',
        update: 'processes.update',
        destroy: 'processes.destroy',
        restart: 'processes.restart',
        start: 'processes.start',
        stop: 'processes.stop'
    },
    roles: {
        index: 'roles.index'
    },
    settings: {
        index: 'settings.index'
    },
    reports: {
        index: 'reports.index',
        store: 'reports.store',
        download: 'reports.download',
        destroy: 'reports.destroy',
        templates: {
            index: 'report.templates.index',
            show: 'report.templates.show',
            store: 'report.templates.store',
            update: 'report.templates.update',
            destroy: 'report.templates.destroy'
        }
    },
    logs: {
        download: 'reports.download',
        destroy: 'reports.destroy'
    }
};
